// extracted by mini-css-extract-plugin
module.exports = {"textarea":"AntTextArea_textarea__1s_pq","maxLength":"AntTextArea_maxLength__2986Z"};